var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1665 45.5V32.5M34.6665 39H47.6665",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 33.5833H16.2502C13.2264 33.5833 11.7146 33.5833 10.4844 33.9565C7.71448 34.7968 5.54692 36.9643 4.70668 39.7342C4.3335 40.9644 4.3335 42.4763 4.3335 45.5M31.4168 16.25C31.4168 21.6348 27.0516 26 21.6668 26C16.2821 26 11.9168 21.6348 11.9168 16.25C11.9168 10.8652 16.2821 6.5 21.6668 6.5C27.0516 6.5 31.4168 10.8652 31.4168 16.25Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserPlus);
export default __webpack_public_path__ + "static/media/IconUserPlus.96282605a2ca67c6abb1ab83b8cb07b8.svg";
export { ForwardRef as ReactComponent };